export const environment = {
  production: true,
  buildId: '2768970169718901',
  configFile: 'config.json',
};
